<div class="h-100-vh pt-5">
    <div class="mt-5 pt-5">
        <span class="material-icons" style="font-size: 5em;">error_outline</span>
        <p class="mt-0">عذرً، ولكن الصفحة التي تحاول الوصول إليها غير متاحة.</p>
        <small class="d-block mt-4"><a href="javascript:history.back()">العودة للصفحة السابقة</a></small>
    </div>
</div>
